import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
//MUI
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Link from '@mui/material/Link';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
//ICONS
//DS
/**
 * Vista de espera y generadora de redireccion con el formato de login data service
 */
function RedirectCallback({
   appName,
   logoApp,
   pasoActual,
   pasos,
   loadingBarProps,
   loadingCircleProps,
   infoMsg,
   infoMsgProps,
   onIrAClick,
   irALabel
}) {
   //Control de los mensajes de carga
   const [loadingMsg, setloadingMsg] = useState('');
   const [loadingValue, setloadingValue] = useState(0);
   function handleModLoading(paso) {
      const total = pasos.length;
      if (paso === -1) {
         setloadingMsg('');
         setloadingValue(0);
      }
      const value = Math.ceil((paso * 100) / total);
      if (paso > -1 && paso < pasos.length) {
         setloadingMsg(`${pasos[paso]} (${paso}/${total})`);
         setloadingValue(value);
      }
      if (paso === pasos.length) {
         setloadingMsg(`Se ha ejecutado todos los procesos. (${paso}/${total})`);
         setloadingValue(value);
      }
   }
   useEffect(() => {
      handleModLoading(pasoActual);
   }, [pasoActual]);

   return (
      <Card style={{height: '100%', width: '100%'}}>
         <Grid
            style={{height: '95%', width: '100%', padding: '10px'}}
            container
            spacing={1}
            alignContent="center"
         >
            <Grid container item xs={12}>
               <Grid container item xs={12} justifyContent="center" alignContent="center">
                  <img
                     style={{maxWidth: '400px'}}
                     alt="Logo"
                     height="100"
                     src={logoApp || 'https://www.dscont.pe/dsServices/images/ds-iso9001-logo.png'}
                  />
               </Grid>
               <Grid container item xs={12} justifyContent="center" alignContent="center">
                  <Typography variant="h5" color="textSecondary">
                     Bienvenido a {appName}.
                  </Typography>
               </Grid>
               {loadingMsg && (
                  <>
                     <Grid item xs={12}>
                        <LinearProgress
                           style={{maxWidth: '400px', marginLeft: 'auto', marginRight: 'auto'}}
                           {...loadingBarProps}
                           variant="determinate"
                           value={loadingValue}
                        />
                     </Grid>
                     <Grid item xs={12}>
                        <Typography align="center" variant="body1" color="textSecondary">
                           {loadingMsg}
                        </Typography>
                     </Grid>
                  </>
               )}
               {infoMsg && (
                  <Grid container item xs={12}>
                     <Grid item xs={12}>
                        <Typography
                           align="center"
                           variant="body2"
                           color="textSecondary"
                           {...infoMsgProps}
                        >
                           {infoMsg}
                        </Typography>
                     </Grid>
                     {typeof onIrAClick === 'function' && (
                        <Grid container item xs={12} justifyContent="center">
                           <Button startIcon={<VpnKeyIcon />} onClick={onIrAClick}>
                              {irALabel || `Ir a Sign-In`}
                           </Button>
                        </Grid>
                     )}
                  </Grid>
               )}
            </Grid>
         </Grid>
         <Grid style={{height: '10%', width: '100%'}} container item xs={12}>
            <Grid item xs={3}>
               <Typography variant="subtitle1" align="center" color="textSecondary" component="p">
                  <Link target="_blank" href="https://www.dscont.pe/" underline="hover">
                     Política de Privacidad
                  </Link>
               </Typography>
            </Grid>
            <Grid item xs={3}>
               <Typography variant="subtitle1" align="center" color="textSecondary" component="p">
                  <Link target="_blank" href="https://www.dscont.pe/" underline="hover">
                     Términos y Condiciones
                  </Link>
               </Typography>
            </Grid>
            <Grid item xs={6}>
               <Typography variant="subtitle1" align="center" color="textSecondary" component="p">
                  Copyright©{new Date().getFullYear()}{' '}
                  <Link target="_blank" href="https://www.dscont.pe/" underline="hover">
                     DsContSoftware
                  </Link>
                  . Todos los derechos reservados.
               </Typography>
            </Grid>
         </Grid>
      </Card>
   );
}
RedirectCallback.propTypes = {
   /**
    * Nombre de la aplicacion que usa el componente.
    */
   appName: PropTypes.string,
   /**
    * Imagen a de espera a mostrar, se sugiere el logo de la app que usa el componente.
    */
   logoApp: PropTypes.string,
   /**
    * Mensajes a mostrar de acuerdo al indice proporcionado por `pasoActual`.
    */
   pasos: PropTypes.arrayOf(PropTypes.string),
   /**
    * Indice del mensaje a mostrar, debe ser menor o igual a la longitud de la propiedad `pasos`.
    *
    * - Si es -1 la barra de carga estara oculta.
    * - Si es igual a la longitude de la propiedad `pasos` la barra de carga se mostrara llena.
    */
   pasoActual: PropTypes.number,
   /**
    * Propiedades adicionales para el componente [Progress](https://mui.com/components/progress/) de Mui que renderiza el mensaje de la barra de carga.
    */
   loadingBarProps: PropTypes.object,
   /**
    * Mensaje de informacion adicional.
    */
   infoMsg: PropTypes.string,
   /**
    * Propiedades adicionales para el componente [Typography](https://mui.com/components/typography/#main-content) de Mui que renderiza el mensaje de información adicional.
    */
   infoMsgProps: PropTypes.object,
   /**
    * Funcion a ejecutar cuando se hace click en el boton `IR A`
    */
   onIrAClick: PropTypes.func,
   /**
    * Label a mostrar en el boton `IR A`
    */
   irALabel: PropTypes.string
};
RedirectCallback.defaultProps = {
   pasoActual: -1
};
export default RedirectCallback;
